<template>
  <div class="thai-hilo-result">
    <!-- <div class="dice-wrapper">
      <div class="result-dice">
        <img
          v-if="diceOneActive==1"
          class="dice-img"
          :src="require(`../../assets/images/thai-hilo/dice-1-active.png`)"
          alt
        />
        <img v-else class="dice-img" :src="require(`../../assets/images/thai-hilo/dice-1.png`)" alt />
      </div>
      <div class="result-dice">
        <img
          v-if="diceTwoActive==1"
          class="dice-img"
          :src="require(`../../assets/images/thai-hilo/dice-2-active.png`)"
          alt
        />
        <img v-else class="dice-img" :src="require(`../../assets/images/thai-hilo/dice-2.png`)" alt />
      </div>
      <div class="result-dice">
        <img
          v-if="diceThreeActive==1"
          class="dice-img"
          :src="require(`../../assets/images/thai-hilo/dice-3-active.png`)"
          alt
        />
        <img v-else class="dice-img" :src="require(`../../assets/images/thai-hilo/dice-3.png`)" alt />
      </div>
      <div class="result-dice">
        <img
          v-if="diceFourActive==1"
          class="dice-img"
          :src="require(`../../assets/images/thai-hilo/dice-4-active.png`)"
          alt
        />
        <img v-else class="dice-img" :src="require(`../../assets/images/thai-hilo/dice-4.png`)" alt />
      </div>
      <div class="result-dice">
        <img
          v-if="diceFiveActive==1"
          class="dice-img"
          :src="require(`../../assets/images/thai-hilo/dice-5-active.png`)"
          alt
        />
        <img v-else class="dice-img" :src="require(`../../assets/images/thai-hilo/dice-5.png`)" alt />
      </div>
      <div class="result-dice">
        <img
          v-if="diceSixActive==1"
          class="dice-img"
          :src="require(`../../assets/images/thai-hilo/dice-6-active.png`)"
          alt
        />
        <img v-else class="dice-img" :src="require(`../../assets/images/thai-hilo/dice-6.png`)" alt />
      </div>
    </div>-->
    <div id="perspective">
      <div id="dice-1" ref="dice-1" class="dice">
        <div ref="dice-1-face-1" class="face dice-1-face-1">
          <div class="dot"></div>
        </div>
        <div ref="dice-1-face-2" class="face dice-1-face-2">
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <div ref="dice-1-face-3" class="face dice-1-face-3">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <div ref="dice-1-face-4" class="face dice-1-face-4">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <div ref="dice-1-face-5" class="face dice-1-face-5">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <div ref="dice-1-face-6" class="face dice-1-face-6">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      <div ref="dice-2" id="dice-2" class="dice2">
        <div ref="dice-2-face-1" class="face dice-2-face-1">
          <div class="dot"></div>
        </div>
        <div ref="dice-2-face-2" class="face dice-2-face-2">
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <div ref="dice-2-face-3" class="face dice-2-face-3">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <div ref="dice-2-face-4" class="face dice-2-face-4">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <div ref="dice-2-face-5" class="face dice-2-face-5">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <div ref="dice-2-face-6" class="face dice-2-face-6">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      <div ref="dice-3" id="dice-3" class="dice3">
        <div ref="dice-3-face-1" class="face dice-3-face-1">
          <div class="dot"></div>
        </div>
        <div ref="dice-3-face-2" class="face dice-3-face-2">
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <div ref="dice-3-face-3" class="face dice-3-face-3">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <div ref="dice-3-face-4" class="face dice-3-face-4">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <div ref="dice-3-face-5" class="face dice-3-face-5">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <div ref="dice-3-face-6" class="face dice-3-face-6">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["gameData", "disallowBetting", "drawResult", "onAnimationEnd"],
  components: {},
  data() {
    return {
      dice1: 0,
      dice2: 0,
      dice3: 0,
      drawCounter: 0,
      tempArr: []
    };
  },
  watch: {
    drawResult() {
      let vm = this;
      this.drawCounter++;
      this.dice1 = this.drawResult.dice1;
      this.dice2 = this.drawResult.dice2;
      this.dice3 = this.drawResult.dice3;

      let tempArr = [this.dice1, this.dice2, this.dice3];
      // console.log("===============");
      // console.log(this.dice1);
      // console.log(this.dice2);
      // console.log(this.dice3);
      // console.log("===============");

      if (this.drawCounter > 1) {
        // console.log("i want to dice this");
        vm.$refs["dice-1"].style.animation = "spin 0.5s linear 2s infinite";
        vm.$refs["dice-2"].style.animation = "spin 0.5s linear 2s infinite";
        vm.$refs["dice-3"].style.animation = "spin 0.5s linear 2s infinite";

        setTimeout(() => {
          vm.$refs["dice-1"].style.animation = "";
          vm.$refs["dice-2"].style.animation = "";
          vm.$refs["dice-3"].style.animation = "";
          for (var x = 0; x <= 2; x++) {
            // console.log("====" + tempArr[x] + "====");
            if (tempArr[x] == 1) {
              // console.log("i masuk 1");
              this.changeDiceResultToOne(x + 1);
            }
            if (tempArr[x] == 2) {
              // console.log("i masuk 2");
              this.changeDiceResultToTwo(x + 1);
            }
            if (tempArr[x] == 3) {
              // console.log("i masuk 3");
              this.changeDiceResultToThree(x + 1);
            }
            if (tempArr[x] == 4) {
              // console.log("i masuk 4");
              this.changeDiceResultToFour(x + 1);
            }
            if (tempArr[x] == 5) {
              // console.log("i masuk 5");
              this.changeDiceResultToFive(x + 1);
            }
            if (tempArr[x] == 6) {
              // console.log("i masuk 6");
              this.changeDiceResultToSix(x + 1);
            }
          }
          this.animationEnd();
        }, 5000);
      }
    }
  },
  methods: {
    animationEnd() {
      this.$emit("on-animation-end");
    },
    // ----------------- Dice 1 Positon -----------------
    changeDiceResultToOne(dice) {
      // console.log("i change 1 method");
      this.$refs["dice-" + dice + "-face-1"].style.transform =
        "translateZ(calc(var(--face-size) / 2))";

      this.$refs["dice-" + dice + "-face-2"].style.transform =
        "translateX(50%) rotateY(90deg)";

      this.$refs["dice-" + dice + "-face-3"].style.transform =
        "translateX(-50%) rotateY(-90deg)";

      this.$refs["dice-" + dice + "-face-4"].style.transform =
        "translateY(50%) rotateX(90deg)";

      this.$refs["dice-" + dice + "-face-5"].style.transform =
        "translateY(-50%) rotateX(-90deg)";

      this.$refs["dice-" + dice + "-face-6"].style.transform =
        "translateZ(calc(var(--face-size) / -2)) rotateY(180deg)";
    },
    // ----------------- Dice 2 Positon -----------------
    changeDiceResultToTwo(dice) {
      // console.log("i change 2 method");
      this.$refs["dice-" + dice + "-face-2"].style.transform =
        "translateZ(calc(var(--face-size) / 2))";

      this.$refs["dice-" + dice + "-face-3"].style.transform =
        "translateZ(calc(var(--face-size) / -2)) rotateY(180deg)";

      this.$refs["dice-" + dice + "-face-4"].style.transform =
        "translateY(50%) rotateX(90deg)";

      this.$refs["dice-" + dice + "-face-5"].style.transform =
        "translateY(-50%) rotateX(-90deg)";

      this.$refs["dice-" + dice + "-face-6"].style.transform =
        "translateX(50%) rotateY(90deg)";

      this.$refs["dice-" + dice + "-face-1"].style.transform =
        "translateX(-50%) rotateY(-90deg)";
    },
    // ----------------- Dice 3 Positon -----------------
    changeDiceResultToThree(dice) {
      this.$refs["dice-" + dice + "-face-3"].style.transform =
        "translateZ(calc(var(--face-size) / 2))";

      this.$refs["dice-" + dice + "-face-4"].style.transform =
        "translateY(50%) rotateX(90deg)";

      this.$refs["dice-" + dice + "-face-5"].style.transform =
        "translateY(-50%) rotateX(-90deg)";

      this.$refs["dice-" + dice + "-face-6"].style.transform =
        "translateX(-50%) rotateY(-90deg)";

      this.$refs["dice-" + dice + "-face-1"].style.transform =
        "translateX(50%) rotateY(90deg)";

      this.$refs["dice-" + dice + "-face-2"].style.transform =
        "translateZ(calc(var(--face-size) / -2)) rotateY(180deg)";
    },
    // ----------------- Dice 4 Positon -----------------
    changeDiceResultToFour(dice) {
      // console.log("i change 4 method");
      this.$refs["dice-" + dice + "-face-4"].style.transform =
        "translateZ(calc(var(--face-size) / 2))";

      this.$refs["dice-" + dice + "-face-5"].style.transform =
        "translateZ(calc(var(--face-size) / -2)) rotateY(180deg)";

      this.$refs["dice-" + dice + "-face-6"].style.transform =
        "translateY(-50%) rotateX(-90deg)";

      this.$refs["dice-" + dice + "-face-1"].style.transform =
        "translateY(50%) rotateX(90deg)";

      this.$refs["dice-" + dice + "-face-2"].style.transform =
        "translateX(50%) rotateY(90deg)";

      this.$refs["dice-" + dice + "-face-3"].style.transform =
        "translateX(-50%) rotateY(-90deg)";
    },
    // ----------------- Dice 5 Positon -----------------
    changeDiceResultToFive(dice) {
      // console.log("i change 5 method");
      this.$refs["dice-" + dice + "-face-5"].style.transform =
        "translateZ(calc(var(--face-size) / 2))";

      this.$refs["dice-" + dice + "-face-6"].style.transform =
        "translateY(-50%) rotateX(-90deg)";

      this.$refs["dice-" + dice + "-face-1"].style.transform =
        "translateY(50%) rotateX(90deg)";

      this.$refs["dice-" + dice + "-face-2"].style.transform =
        "translateX(50%) rotateY(90deg)";

      this.$refs["dice-" + dice + "-face-3"].style.transform =
        "translateX(-50%) rotateY(-90deg)";

      this.$refs["dice-" + dice + "-face-4"].style.transform =
        "translateZ(calc(var(--face-size) / -2)) rotateY(180deg)";
    },
    // ----------------- Dice 5 Positon -----------------
    changeDiceResultToSix(dice) {
      // console.log("i change 6 method");
      this.$refs["dice-" + dice + "-face-6"].style.transform =
        "translateZ(calc(var(--face-size) / 2))";

      this.$refs["dice-" + dice + "-face-1"].style.transform =
        "translateZ(calc(var(--face-size) / -2)) rotateY(180deg)";

      this.$refs["dice-" + dice + "-face-2"].style.transform =
        "translateX(50%) rotateY(90deg)";

      this.$refs["dice-" + dice + "-face-3"].style.transform =
        "translateX(-50%) rotateY(-90deg)";

      this.$refs["dice-" + dice + "-face-4"].style.transform =
        "translateY(-50%) rotateX(-90deg)";

      this.$refs["dice-" + dice + "-face-5"].style.transform =
        "translateY(50%) rotateX(90deg)";
    }
  },
  mounted() {
    this.dice1 = this.gameData.prev.dice1;
    this.dice2 = this.gameData.prev.dice2;
    this.dice3 = this.gameData.prev.dice3;

    let tempArr = [this.dice1, this.dice2, this.dice3];

    for (var x = 0; x <= 2; x++) {
      if (tempArr[x] == 1) {
        this.changeDiceResultToOne(x + 1);
      }
      if (tempArr[x] == 2) {
        this.changeDiceResultToTwo(x + 1);
      }
      if (tempArr[x] == 3) {
        this.changeDiceResultToThree(x + 1);
      }
      if (tempArr[x] == 4) {
        this.changeDiceResultToFour(x + 1);
      }
      if (tempArr[x] == 5) {
        this.changeDiceResultToFive(x + 1);
      }
      if (tempArr[x] == 6) {
        this.changeDiceResultToSix(x + 1);
      }
    }
  }
};
</script>
<style lang="scss">
:root {
  --face-size: 50px;
  --dot-size: calc(var(--face-size) * 0.225);
  background-color: rgba(175, 175, 175, 0.25);
}

/* Set perspective in wrapper */
#perspective {
  position: absolute;
  perspective: 35000px;
  text-align: center;
  position: relative;
  line-height: 10;
}

.dice:hover,
.dice2:hover,
.dice3:hover {
  animation: shake 0.5s;
  animation-iteration-count: infinite;
}

/* Create spin animation */
@keyframes spin {
  from {
    transform: rotateX(0deg) rotateY(0deg);
  }
  to {
    transform: rotateX(360deg) rotateY(720deg);
  }
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}

/* Position dice on page */
#dice-1,
#dice-2,
#dice-3 {
  display: inline-block;
  position: relative;
}

/* Set dice style */
.dice,
.dice2,
.dice3 {
  position: absolute;
  width: var(--face-size);
  height: var(--face-size);
  transform-style: preserve-3d;
  margin: 25px;
  // animation: spin 10s linear 2s infinite;
}

// .dice2 {
//   position: absolute;
//   width: var(--face-size);
//   height: var(--face-size);
//   transform-style: preserve-3d;
//   // animation: spin 1s linear 2s infinite;
// }

// .dice3 {
//   position: absolute;
//   width: var(--face-size);
//   height: var(--face-size);
//   transform-style: preserve-3d;
//   // animation: spin 1s linear 2s infinite;
// }

/* Stop animation when hovering over dice */
.dice:hover {
  animation-play-state: paused;
}

/* Set dice face style */
.face {
  position: absolute;
  font-size: 40px;
  width: var(--face-size);
  height: var(--face-size);
  text-align: center;
  line-height: var(--face-size);
  border: 1px solid black;
  transform-style: preserve-3d;
  background-color: white;
}

/* Position face 1 and dots */
.dice-1-face-1,
.dice-2-face-1,
.dice-3-face-1 {
  transform: translateZ(calc(var(--face-size) / -2)) rotateY(180deg);
}
.dice-1-face-1 > .dot,
.dice-2-face-1 > .dot,
.dice-3-face-1 > .dot {
  left: 50%;
  top: 50%;
}

/* Position face 2 and dots */
.dice-1-face-2,
.dice-2-face-2,
.dice-3-face-2 {
  transform: translateX(50%) rotateY(90deg);
}
.dice-1-face-2 > .dot:nth-child(1),
.dice-2-face-2 > .dot:nth-child(1),
.dice-3-face-2 > .dot:nth-child(1) {
  left: 25%;
  top: 50%;
}
.dice-1-face-2 > .dot:nth-child(1),
.dice-2-face-2 > .dot:nth-child(1),
.dice-3-face-2 > .dot:nth-child(1) {
  left: 25%;
  top: 50%;
}
.dice-1-face-2 > .dot:nth-child(2),
.dice-2-face-2 > .dot:nth-child(2),
.dice-3-face-2 > .dot:nth-child(2) {
  left: 75%;
  top: 50%;
}

/* Position face 3 and dots */
.dice-1-face-3,
.dice-2-face-3,
.dice-3-face-3 {
  transform: translateX(-50%) rotateY(-90deg);
}
.dice-1-face-3 > .dot:nth-child(1),
.dice-2-face-3 > .dot:nth-child(1),
.dice-3-face-3 > .dot:nth-child(1) {
  left: 25%;
  top: 25%;
}
.dice-1-face-3 > .dot:nth-child(2),
.dice-2-face-3 > .dot:nth-child(2),
.dice-3-face-3 > .dot:nth-child(2) {
  left: 50%;
  top: 50%;
}
.dice-1-face-3 > .dot:nth-child(3),
.dice-2-face-3 > .dot:nth-child(3),
.dice-3-face-3 > .dot:nth-child(3) {
  left: 75%;
  top: 75%;
}

/* Position face 4 and dots */
.dice-1-face-4,
.dice-2-face-4,
.dice-3-face-4 {
  transform: translateY(50%) rotateX(90deg);
}
.dice-1-face-4 > .dot:nth-child(1),
.dice-2-face-4 > .dot:nth-child(1),
.dice-3-face-4 > .dot:nth-child(1) {
  left: 25%;
  top: 25%;
}
.dice-1-face-4 > .dot:nth-child(2),
.dice-2-face-4 > .dot:nth-child(2),
.dice-3-face-4 > .dot:nth-child(2) {
  left: 75%;
  top: 25%;
}
.dice-1-face-4 > .dot:nth-child(3),
.dice-2-face-4 > .dot:nth-child(3),
.dice-3-face-4 > .dot:nth-child(3) {
  left: 25%;
  top: 75%;
}
.dice-1-face-4 > .dot:nth-child(4),
.dice-2-face-4 > .dot:nth-child(4),
.dice-3-face-4 > .dot:nth-child(4) {
  left: 75%;
  top: 75%;
}

/* Position face 5 and dots */
.dice-1-face-5,
.dice-2-face-5,
.dice-3-face-5 {
  transform: translateY(-50%) rotateX(-90deg);
}
.dice-1-face-5 > .dot:nth-child(1),
.dice-2-face-5 > .dot:nth-child(1),
.dice-3-face-5 > .dot:nth-child(1) {
  left: 25%;
  top: 25%;
}
.dice-1-face-5 > .dot:nth-child(2),
.dice-2-face-5 > .dot:nth-child(2),
.dice-3-face-5 > .dot:nth-child(2) {
  left: 75%;
  top: 25%;
}
.dice-1-face-5 > .dot:nth-child(3),
.dice-2-face-5 > .dot:nth-child(3),
.dice-3-face-5 > .dot:nth-child(3) {
  left: 25%;
  top: 75%;
}
.dice-1-face-5 > .dot:nth-child(4),
.dice-2-face-5 > .dot:nth-child(4),
.dice-3-face-5 > .dot:nth-child(4) {
  left: 75%;
  top: 75%;
}
.dice-1-face-5 > .dot:nth-child(5),
.dice-2-face-5 > .dot:nth-child(5),
.dice-3-face-5 > .dot:nth-child(5) {
  left: 50%;
  top: 50%;
}

/* Position face 6 and dots */
.dice-1-face-6,
.dice-2-face-6,
.dice-3-face-6 {
  transform: translateZ(calc(var(--face-size) / 2));
}
.dice-1-face-6 > .dot:nth-child(1),
.dice-2-face-6 > .dot:nth-child(1),
.dice-3-face-6 > .dot:nth-child(1) {
  left: 25%;
  top: 25%;
}
.dice-1-face-6 > .dot:nth-child(2),
.dice-2-face-6 > .dot:nth-child(2),
.dice-3-face-6 > .dot:nth-child(2) {
  left: 75%;
  top: 25%;
}
.dice-1-face-6 > .dot:nth-child(3),
.dice-2-face-6 > .dot:nth-child(3),
.dice-3-face-6 > .dot:nth-child(3) {
  left: 25%;
  top: 50%;
}
.dice-1-face-6 > .dot:nth-child(4),
.dice-2-face-6 > .dot:nth-child(4),
.dice-3-face-6 > .dot:nth-child(4) {
  left: 75%;
  top: 50%;
}
.dice-1-face-6 > .dot:nth-child(5),
.dice-2-face-6 > .dot:nth-child(5),
.dice-3-face-6 > .dot:nth-child(5) {
  left: 25%;
  top: 75%;
}
.dice-1-face-6 > .dot:nth-child(6),
.dice-2-face-6 > .dot:nth-child(6),
.dice-3-face-6 > .dot:nth-child(6) {
  left: 75%;
  top: 75%;
}

/* Set dot style */
.dot {
  position: absolute;

  width: var(--dot-size);
  height: var(--dot-size);

  border-radius: 50%;

  background-color: black;

  transform: translate(-50%, -50%);
}
</style>

<style lang="scss" scoped>
.thai-hilo-result {
  width: 100%;
  height: 100px;
  display: block;
  position: relative;
  text-align: center;
}

.result-dice {
  display: inline-block;
  position: relative;
  width: 12%;
  align-content: center;
  margin: 2px;
}

.dice-wrapper {
  position: relative;
  top: 28px;
}

.dice-img {
  width: 100%;
}
</style>